// extracted by mini-css-extract-plugin
export default {"winnersContainer":"Results_winnersContainer__FUo8B","winner":"Results_winner__3omOa","list":"Results_list__qrIpB","title":"Results_title__1v+iC","crown":"Results_crown__1e9Zr"};